import React from "react";
import { ShieldCheckIcon, CheckIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { guaranteeItems } from "../data/content";
export function Guarantee() {
  return <section className="bg-cream px-4 py-16 sm:py-24" aria-labelledby="guarantee-title" data-id="element-129" data-mp="223y639n82bl6">
      <div className="mx-auto max-w-3xl text-center" data-id="element-130" data-mp="1x4l93w2mzo4v">
        <div className="mx-auto flex h-32 w-32 flex-col items-center justify-center rounded-full border-[6px] border-double border-gold bg-wine-800 text-white" data-id="element-131" data-mp="1x54qnbodkaid">
          <ShieldCheckIcon className="h-9 w-9 text-gold" aria-hidden="true" data-id="element-132" data-mp="14gfmf3s0vp2e" />
          <span className="mt-1 font-serif text-3xl font-extrabold leading-none" data-id="element-133" data-mp="1j4aganhrnzh2">7</span>
          <span className="text-[10px] font-bold uppercase tracking-widest" data-id="element-134" data-mp="1edu1p027m7t4">Day guarantee</span>
        </div>
        <h2 id="guarantee-title" className="mt-7 font-serif text-3xl font-bold leading-tight text-ink sm:text-5xl" data-id="element-135" data-mp="qnzq0ltmmpag">
          7-day <em className="text-wine-700" data-id="element-136" data-mp="lpy7q340yu01">money-back guarantee</em>
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-[17px] leading-relaxed text-ink-soft" data-id="element-137" data-mp="ozro0as4edzt">
          I want you to be able to explore the War Room and decide for yourself whether it fits the way you learn. For 7 days, you can:
        </p>

        <ul className="mx-auto mt-8 grid max-w-xl grid-cols-1 gap-3 text-left min-[420px]:grid-cols-2" data-id="element-138" data-mp="yqmczmwr3roy">
          {guaranteeItems.map(item => <li key={item} className="flex items-center gap-2.5 rounded-xl bg-white px-4 py-3 text-[15px] font-semibold text-ink ring-1 ring-wine-100" data-id="element-139" data-mp="60njnfbix8eh">
              <CheckIcon className="h-5 w-5 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-140" data-mp="b0jofgs1p3v3" />
              {item}
            </li>)}
        </ul>

        <p className="mx-auto mt-8 max-w-2xl text-[17px] leading-relaxed text-ink-soft" data-id="element-141" data-mp="k0yaiicu2mzn">
          If you decide that BIOMECHANICS WAR ROOM™ isn't the right fit for you, you can request a refund within the applicable guarantee period.
        </p>

        <div className="mt-10" data-id="element-142" data-mp="1ve0ttl6bhqni">
          <CtaButton label="Try it risk-free for 7 days" data-id="element-143" data-mp="3riqcohkg39r6" />
        </div>
      </div>
    </section>;
}